<template>
    <div>
        <TextyKnihaPage
            v-if="!temaKod && book"
            :book
        />
        <TextyTemaPage
            v-else-if="temaKod && book"
            :book
            :tema-kod="temaKod"
        />
    </div>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n()
const route = useRoute()
const booksStore = useBooksStore()

const bookKod = (route.params.kody as string[])[0]
const temaKod: string | undefined = getTemaKod()

function getTemaKod() {
    if ((route.params.kody as string[]).length > 1) {
        return (route.params.kody as string[])[1]
    }
    if (locale.value === "en") {
        return "1"
    }
    return undefined
}

// console.log("Kniha ID: ", bookKod)
// console.log("Téma ID: ", temaKod)

/* if (route.params.kody.length > 1) {
    definePageMeta({
        title: `Téma ${bookKod}.${temaKod}`,
    })
} else {
    definePageMeta({
        title: `Obsah knihy ${bookKod}`,
    })
} */

useSeoMeta({
    title: () =>
        temaKod !== undefined
            ? `${t("texty.tema_title")}${bookKod}.${temaKod}`
            : `${t("texty.kniha_title")}${bookKod}`,
    ogTitle: () =>
        temaKod !== undefined
            ? `${t("texty.tema_title")}${bookKod}.${temaKod} | %siteName`
            : `${t("texty.kniha_title")}${bookKod} | %siteName`,
})

await useAsyncData(`book-${bookKod}-tree`, async () => {
    return await booksStore.fetchBookTree(
        locale.value as LanguageCode,
        bookKod as string
    )
})

const book = computed(() => {
    return booksStore.books[locale.value as LanguageCode].find(
        item => item.kod === bookKod
    )
})
</script>

<style scoped></style>
